// extracted by mini-css-extract-plugin
module.exports = {"preamble":"layout-module--preamble--8eyLs","main":"layout-module--main--3S3ac"};